import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { UserService } from 'src/app/core/services/user.service';
import { ICase } from 'src/app/modules/cases/interfaces/case.interface';
import { TaskCase } from '../../interface/task.interface';
import { TaskService } from '../../services/task.service';
import { TaskCaseService } from '../../services/taskCase.service';
import { SeeTaskCaseComponent } from '../see-task-case/see-task-case.component';

@Component({
  selector: 'task-case-card',
  templateUrl: './task-case-card.component.html',
  styleUrls: ['./task-case-card.component.scss'],
})
export class TaskCaseCardComponent implements OnInit {
  @Input() clickable: boolean = false;

  get required() {
    return this.task.required;
  }
  get deleted() {
    return this.task.deleted;
  }
  @Input() task: any;
  @Input() case: ICase;

  constructor(
    private readonly dialog: MatDialog,
    private readonly snackBar: MatSnackBar,
    private readonly taskCaseService: TaskCaseService,
    private readonly userService: UserService
  ) {}

  ngOnInit() {}

  get needApproval() {
    try {
      const { approvalRoles } = this.case?.caseType;
      const { approvalStatus } = this.case;
      const roleId = this.userService.currentUser.role._id;
      if (
        approvalRoles?.levelOne == roleId &&
        approvalStatus == 'requestLevelOne'
      ) {
        return true;
      }
      if (
        approvalRoles?.levelTwo == roleId &&
        approvalStatus == 'requestLevelTwo'
      ) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }
  openTask() {
    if (!this.clickable) return;
    if (
      this.case.status == 'running' ||
      this.case.status == 'archived' ||
      this.needApproval ||
      (this.userService.currentUser.role.createCases &&
        this.case.status == 'toFinalize')
    ) {
      let maxWidth = '800px';
      // if (tarea.titulo == 'Registrar Hipotesis.') maxWidth = '1000px';
      const ref = this.dialog
        .open(SeeTaskCaseComponent, {
          data: this.task,
          width: '90vw',
          maxWidth,
          maxHeight: '95vh',
          disableClose: true,
          panelClass: 'modalVerTarea',
        })
        .afterClosed()
        .subscribe({
          next: (response) => {
            if (response?.action == 'updated') {
              this.task = response.task;
              this.taskCaseService.taskUpdated.next(response);
              this.alert('La tarea ha sido editada');
            }
            if (response?.action == 'deleted') {
              this.task.deleted = true;
              this.alert('La tarea ha sido eliminada');
            }
          },
        });
    } else {
      this.snackBar.open(`El caso actual no se encuentra en ejecución`, `x`);
    }
  }

  alert(message) {
    this.dialog.open(SuccessComponent, {
      data: { title: message },
    });
  }
}
